import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { TextInput } from '../CustomerAccounts/LoanFormFields';

// Edit the title / instructions shown in the app for one photo or video of an
// activity (side panel). The activity and media type are shown, not edited.
export default function FormProgressMedia({
  activityType,
  activityName,
  mediaType,
  title,
  instruction,
  handleChange,
}) {
  return (
    <div className='lf-grid'>
      <div className='lf-span-12 cp-context'>
        <span>{activityType}</span>
        <span>{activityName}</span>
        <span>{mediaType}</span>
      </div>
      <TextInput
        id='title'
        label='Title'
        span={12}
        value={title}
        onChange={(id) => handleChange(id)}
      />
      <TextInput
        id='instruction'
        label='Instructions'
        span={12}
        multiline
        rows={4}
        value={instruction}
        onChange={(id) => handleChange(id)}
      />
    </div>
  );
}
